import { FinancialPublication } from '@lglp/prismic-client';
import { compact } from '@lglp/utils';

import { SortBy } from '../../api/algolia';
import { DocumentType } from '../../types/document';
import { and, attr, attributeIn } from '../algolia/algolia-filters-builder';

export const searchRegulatedInformation = ({
  hitsPerPage = 10,
  financialPublicationTypes,
}: SearchRegulatedInformationProps): SearchRegulatedInformationReturnProps => {
  return compact<SearchRegulatedInformationReturnProps>({
    sortBy: SortBy.PUBLISHED_AT,
    hitsPerPage,
    facets: [],
    filters: and(
      [
        attr('type', DocumentType.MEDIA_PRESS),
        attr('filters.mediaType', 'publication'),
        attr('onFinance', 'true'),
        attributeIn('filters.financialPublication')(financialPublicationTypes),
      ].filter(Boolean) as string[]
    ),
  });
};

type SearchRegulatedInformationProps = {
  hitsPerPage: number;
  financialPublicationTypes: FinancialPublication[];
};

type SearchRegulatedInformationReturnProps = {
  sortBy: SortBy;
  hitsPerPage: number;
  facets: string[];
  filters: string;
};
